import { useRef, useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usePrevious = (value: any) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref) {
      ref.current = value;
    }
  }, [value]);

  return ref.current;
};
